import { useState, useEffect, useRef, useCallback } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../Lib/contextLib";
import { getVideo, GetUserVideo } from "../../s3Func/s3Download";
import Amplify, { API, Auth } from "aws-amplify";
import PopUp from "../../Popup/logoutPopup";
import { CloudfrontVideoFormat } from "../../videos/CloudfrontVideoFormat";
import "./Module10World.css";

import Learn from "../../Learn/Learn";
import Practice from "./../../Unit1/Module5/DistancePractice";
import Day4Practice from "./../Day4Practice/Day4Practice";
import SingingTime from '../../SingingTime/SingingTime';
import Celebrate from "../../Celebrate/Celebrate";
import Surprise from "../../SurpriseVideo/surprise";
import FollowTheBeatModule10 from "../../FollowTheBeat/FollowTheBeatModule10.js";
import presentSound from "./../../Unit1/Module1/assets/ta_da_gift.mp3";

// Constants
const TIMING = {
  BUTTON_AUDIO_DELAY: 700,
  ANIMATION_DELAY: 500,
  KEY_ANIMATION_DELAY: 1000,
  EGG_ANIMATION_DELAY: 2000,
  IOS_VOICE_TIMEOUT: 5000,
};

const COIN_THRESHOLDS = {
  PRIZE_UNLOCK: 100,
  TWO_DIGIT: 10,
  THREE_DIGIT: 100,
};

const STEP_COMPLETED = {
  NOT_STARTED: 'notstarted',
  SINGING_TIME: 'singingtime',
  LEARN: 'learn',
  PRACTICE: 'practice',
  FOLLOW_THE_BEAT: 'followthebeat',
  CELEBRATE: 'celebrate',
  SURPRISE: 'surprise',
};

const MODULE_NAME = 'Distance';
const MODULE_NUM = 'MODULE10';
const SECTION_COMPLETED_THRESHOLD = 4;

const Module10World = () => {
  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module10 } = useSelector((state) => state.module10, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl("images/Module10Images/Unit2_Mod5BGupdated.png");
  const mountain = generateImageUrl("images/newDesign/Unit2Module10/World10MountainOnly.png");
  const animal = generateImageUrl("images/Module5Images/Bird+Closing+still.gif");
  const progressbar0 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_0.svg");
  const progressbar1 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_Third.svg");
  const progressbar2 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_2Thirds.svg");
  const progressbar3 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_2Thirds.svg");
  const progressbarCompleted = generateImageUrl("images/Module5Images/Mod5_ProgressBar_Completed.svg");
  const journeyImage = generateImageUrl("images/Module1Images/bluejourneymap.svg");
  const coinPick = generateImageUrl("images/Images/AwesomeCoin.png");
  const coinBar = generateImageUrl("images/Images/Coin+Counter.png");
  const logoutBtn = generateImageUrl("images/Module1Images/Logout.png");
  const reviewBtn = generateImageUrl("images/Module1Images/Button_Review.png");
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png');
  const celebrateBtn = generateImageUrl("images/Module1Images/Button_Celebrate.png");
  const learnBtn = generateImageUrl("images/Module1Images/Button_Learn.png");
  const practiceBtn = generateImageUrl("images/Module1Images/Button_Practice.png");
  const ftbBtn = generateImageUrl("images/Images/Button_FTB.png");
  const keyReward = generateImageUrl('images/Module5Images/Worm.png');
  const Egg = generateImageUrl("images/Module5Images/Egg.png");
  const nest = generateImageUrl("images/Module20Images/Nest.svg");
  const eggBottom = generateImageUrl("images/Module5Images/Egg+Crack+Bottom.png");
  let eggTop = generateImageUrl("images/Module5Images/Egg+Crack+Top.png");
  let CometOrange = generateImageUrl("images/Module10Images/DailyReward_CometOrange.png");
  let Alien2 = generateImageUrl("images/Module10Images/DailyReward_Alien2.png");
  let Planet1 = generateImageUrl("images/Module10Images/DailyReward_Planet1.png");
  let Planet2 = generateImageUrl("images/Module10Images/DailyReward_Planet2.png");
  let Helmet1 = generateImageUrl("images/Module10Images/DailyReward_SpaceHelment1.png");
  let Alien1 = generateImageUrl("images/Module10Images/DailyReward_Alien1.png");
  let Constellation2 = generateImageUrl("images/Module10Images/DailyReward_Constellation1_1.png");
  let Stars2 = generateImageUrl("images/Module10Images/DailyReward_Stars2.png");
  let Helmet2 = generateImageUrl("images/Module10Images/DailyReward_SpaceHelment2.png");
  let Constellation1 = generateImageUrl("images/Module10Images/DailyReward_Constellation1.png");
  let UFO2 = generateImageUrl("images/Module10Images/DailyReward_UFO2.png");
  let UFO1 = generateImageUrl("images/Module10Images/DailyReward_UFO1.png");
  let Rocket1 = generateImageUrl("images/Module10Images/DailyReward_Rocket1.png");
  let Rocket2 = generateImageUrl("images/Module10Images/DailyReward_Rocket2.png");
  let CometBlue = generateImageUrl("images/Module10Images/DailyReward_CometBlue.png");
  let Stars1 = generateImageUrl("images/Module10Images/DailyReward_Stars1.png");
  let NorthernLights = generateImageUrl("images/newDesign/Unit2Module10/NorthernLightsSky.png");
  let Galaxy = generateImageUrl("images/Module10Images/BigReward_Galaxy.png");
  let greenCheck = generateImageUrl("images/Module1Images/GreenCheck-Button.png");
  let SingingTimeIcon = generateImageUrl("images/Module1Images/Button_SingingTime.png");
  let AfterCelebrateVideo9 = getVideo('appfiles/close/closing.mp4', login);
  let present = generateImageUrl("images/Images/Gift.png");
  let eggCrackAudio = new Audio(generateImageUrl("media/Module5Videos/egg_crack.mp3"));
  let eggHalfCracked = generateImageUrl("images/Module5Images/EggCrack_3.png");
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'))

  let [reviewIcon, setReviewIcon] = useState(false);
  let [keyIcon, setKeyIcon] = useState(false);
  let [coinIcon, setCoinIcon] = useState(false);
  let [presentIcon, setPresentIcon] = useState(false);
  let [rewardOption1, setRewardOption1] = useState(null);
  let [rewardOption2, setRewardOption2] = useState(null);
  let [displayReward, setDisplayReward] = useState(false);

  let [eggAnimate, setEggAnimate] = useState(false);
  let [eggAnimationState, setEggAnimationState] = useState("");

  let [audioReady, setAudioReady] = useState(false);

  let [displayLearn, setDisplayLearn] = useState(false);
  let [displayPractice, setDisplayPractice] = useState(false);
  let [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  let [displaySingingTime, setDisplaySingingTime] = useState(false);
  let [displayFTB, setDisplayFTB] = useState(false);
  let [displayCelebrate, setDisplayCelebrate] = useState(false);
  let [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setDisplayGreenButton] = useState(false);
  let [learn, setLearn] = useState("");
  let [singTime, setSingTime] = useState("");
  let [celebrate, setCelebrate] = useState("");
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  let [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  let [introVideo, setIntroVideo] = useState("");
  let [displaySurprise, setDisplaySurprise] = useState(false);
  let [surpriseVideo, setSurpriseVideo] = useState("");
  let [displayVoice, setDisplayVoice] = useState(false);
  let [animalVoice, setAnimalVoice] = useState("");
  let [day4Practice, setDay4Practice] = useState("");
  let [prize, setPrize] = useState(false);
  const [displayPrize, setDisplayPrize] = useState(false);
  let [checkStep, setCheckStep] = useState("");

  // ==================== iOS Detection ====================
  const isIOS = () => {
    return (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  };
  let [keyState, setKeyState] = useState("");
  let [eggHalf, setEggHalf] = useState(false);
  let [eggState, setEggState] = useState(Egg);

  let keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  let keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  let [touchButton, setTouchButton] = useState(false);
  let [checkSound, setCheckSound] = useState(false);
  let [buttonSound, setButtonSound] = useState(false);
  let [rewardsFound, setRewardsFound] = useState(false);
  let [coinAnimationState, setCoinAnimationState] = useState("bounceIcons");
  let [coinAudio, setCoinAudio] = useState(false);
  let [birdAwesomeJob, setBirdAwesomeJob] = useState(false);
  let [birdAwesomeJobGIF, setBirdAwesomeJobGIF] = useState(false);

  let [specialMessage, setSpecialMessage] = useState(false);
  let [watchConversation, setWatchConversation] = useState(false);
  let [practiceIntro, setPracticeIntro] = useState("");
  let [learnIntro, setLearnIntro] = useState("");
  let [ftbIntro, setFtbIntro] = useState("");
  let [celebrateIntro, setCelebrateIntro] = useState("");
  let [animalClose, setAnimalClose] = useState(false);
  let [playAnimalClose, setPlayAnimalClose] = useState(false);
  let [animalCloseAudio, setAnimalCloseAudio] = useState(false);
  let [showAnimal, setShowAnimal] = useState(false);
  let [animalState, setAnimalState] = useState("");
  let [amazingJob, setAmazingJob] = useState(false);
  const [showReward, setShowReward] = useState(false);

  let [ftbMusic, setFTBMusic] = useState("");
  let [ftbInstruction, setFTBInstruction] = useState("");
  let [ftbInstructionGIF, setFTBInstructionGIF] = useState("");
  let [ftbCount, setFTBCount] = useState("");
  let [ftbTutorial1, setFTBTutorial1] = useState("");
  let [ftbTutorial2, setFTBTutorial2] = useState("");
  let [ftbWT, setFTBWalkThrough] = useState("");
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  // ==================== Audio & iOS Compatibility ====================
  // Utility function for delays
  const sleep = useCallback((ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }, []);

  // ==================== Media Loading ====================
  const getGifs = useCallback(() => {

    setBirdAwesomeJob(getVideo('appfiles/close/close_awesome_job.mp3', login));
    setBirdAwesomeJobGIF(getVideo('appfiles/close/awesome job.gif', login));
    setSpecialMessage(getVideo('appfiles/close/practice special message.gif', login));
    setWatchConversation(getVideo('appfiles/close/practice watch conversation.gif', login));
    setFTBInstruction(getVideo('appfiles/close/close_ftb_instructions.mp3', login));
    setFTBInstructionGIF(getVideo('appfiles/close/FTB intructions.gif', login));
    setFTBMusic(getVideo('appfiles/close/ftb close with counting.mp3', login));
    setFTBCount(getVideo('appfiles/close/countingBird.gif', login));

    if (!module10.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/greet/ftb_walkthrough_touch_circle.mp3', login));
      setFTBTutorial2(getVideo('appfiles/greet/ftb_walkthrough_count_touch.mp3', login));
      setFTBWalkThrough(getVideo('appfiles/close/ftb_walkthrough_audio.mp3', login));
    }

    setPracticeIntro(getVideo('appfiles/close/practice intro.gif', login));
    setLearnIntro(getVideo('appfiles/close/learn intro.gif', login));
    setFtbIntro(getVideo('appfiles/close/ftb intro.gif', login));
    setAmazingJob(getVideo('appfiles/close/awesome job.gif', login));
    setCelebrateIntro(getVideo('appfiles/close/close_celebrate_intro.gif', login));
    setAnimalClose(getVideo('appfiles/close/day finished.gif', login));
    setAnimalCloseAudio(getVideo('appfiles/close/close_day_finished.mp3', login));
  }, []);

  useEffect(() => {
    getGifs();
  }, [getGifs]);

  useEffect(() => {
    let timer;
    if (displayVoice && isIOS()) {
      timer = setTimeout(() => {
        setAudioReady(false);
        setDisplayVoice(false);
        setAnimalState('');
        setShowAnimal(false);
        if (playAnimalClose) {
          setPlayAnimalClose(false);
          module10.currentday === 8 ? closeDay9Video() : navigate('/close/navigation');
        }
      }, TIMING.IOS_VOICE_TIMEOUT);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [displayVoice]);

  useEffect(() => {
    let timer;
    if (coinAudio && isIOS()) {
      timer = setTimeout(() => {
        dispatch({ type: 'MODULE10_SET_COIN', payload: module10.coins + 1 });
        setCoinAudio(false);
        setCoinAnimationState('bounceIcons');
        setCoinIcon(false);
        playButtonAudio();
      }, TIMING.IOS_VOICE_TIMEOUT);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [coinAudio]);

  const createGameDetails = (flag, reward, coin) => {
    let game_detail = module10.game_details;
    if (flag) {
      let flags = { flag: flag, lastUpdated: new Date().toJSON() };
      game_detail.moduleFlags.push(flags);
    }
    if (coin >= 0) {
      game_detail.tokens_earned = coin;
    }
    if (reward) {
      let dailyRewards = [];
      for (let key in module10.rewards) {
        if (module10.rewards[key] === true) {
          let rewards = { type: key, x_multiplier: 1, y_multiplier: 1 };
          dailyRewards.push(rewards);
        }
      }
      game_detail.dailyRewards = dailyRewards;
    }
    dispatch({ type: "MODULE10_SET_GameDetials", payload: game_detail });
  };

  // ==================== Database & Game Logic ====================
  const updateProgress = async () => {
    const payload = {
      body: {
        id: login.studentid,
        module: MODULE_NAME,
        day_completed: module10.currentday,
        time_completed: new Date().toDateString(),
      },
    };
    try {
      await API.put('TIR', '/v3/student/progress', payload);
    } catch (error) {
      // Progress update failed silently
    }
  };

  useEffect(() => {
    if (
      (module10.reviewIcon === true || login.grade === 'Teacher Account') &&
      module10.sectionCompleted === SECTION_COMPLETED_THRESHOLD
    ) {
      updateProgress();
      module10.sectionCompleted = 0;
    }
  }, [module10.sectionCompleted]);

  const updateDB = async () => {
    const modulePayload = {
      body: {
        id: module10.moduleID,
        day_completed: module10.day_completed,
        step_completed: module10.stepCompleted,
        game_details: JSON.stringify(module10.game_details),
      },
    };

    try {
      await API.put('TIR', '/v3/student/module', modulePayload);
      if (displayGreenButton) {
        setAnimalState(animalClose);
        setShowAnimal(true);
        setPlayAnimalClose(true);
        setAnimalVoice(animalCloseAudio);
        setDisplayGreenButton(false);
        setDisplayReward(false);
      }
    } catch (error) {
      const criticalSteps = [
        STEP_COMPLETED.NOT_STARTED,
        STEP_COMPLETED.LEARN,
        STEP_COMPLETED.PRACTICE,
        STEP_COMPLETED.CELEBRATE,
        STEP_COMPLETED.FOLLOW_THE_BEAT,
      ];
      if (criticalSteps.includes(module10.stepCompleted)) {
        window.alert('Connection is lost. Please login again.');
        dispatch({ type: 'CLEAR' });
        Auth.signOut();
        navigate('/');
      }
    }

    // Update student's current module
    const studentPayload = {
      body: {
        id: login.studentid,
        current_module: MODULE_NAME,
      },
    };
    try {
      await API.put('TIR', '/v3/student', studentPayload);
    } catch (error) {
      // Student update failed silently
    }
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Account" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module10.stepCompleted]);

  useEffect(() => {
    if (module10.coins >= COIN_THRESHOLDS.PRIZE_UNLOCK) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module10.coins);
      updateDB();
    }
  }, [module10.coins]);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (module10.currentday <= module10.day_completed || login.grade === "Teacher Account" || login.grade === 'Free Play')
     {
      if(login.grade === "Teacher Account" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: "MODULE10_TOGGLE_REVIEW_ICON", payload: true });
      dispatch({ type: "MODULE10_SET_KEY", payload: 4 });
      if (module10.currentday == 4 || module10.currentday == 8) {
        dispatch({ type: "MODULE10_SET_KEY", payload: 5 });
      }
    } else {
      if (module10.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: "MODULE10_TOGGLE_REVIEW_ICON", payload: false });
      if (module10.currentday === 4 && module10.day_completed === 3) {
        if (module10.stepCompleted === STEP_COMPLETED.NOT_STARTED) {
          dispatch({ type: "MODULE10_SET_KEY", payload: 0 });
        } else if (module10.stepCompleted === "singingtime") {
          dispatch({ type: "MODULE10_SET_KEY", payload: 1 });
        } else if (module10.stepCompleted === STEP_COMPLETED.LEARN) {
          dispatch({ type: "MODULE10_SET_KEY", payload: 2 });
        } else if (module10.stepCompleted === STEP_COMPLETED.PRACTICE) {
          dispatch({ type: "MODULE10_SET_KEY", payload: 3 });
        } else if (module10.stepCompleted === "followthebeat") {
          dispatch({ type: "MODULE10_SET_KEY", payload: 4 });
        } else if (module10.stepCompleted === "celebrate") {
          setKeyIcon(true);
          dispatch({ type: "MODULE10_SET_KEY", payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module10.stepCompleted === STEP_COMPLETED.NOT_STARTED) {
          dispatch({ type: "MODULE10_SET_KEY", payload: 0 });
        } else if (module10.stepCompleted === STEP_COMPLETED.LEARN) {
          dispatch({ type: "MODULE10_SET_KEY", payload: 1 });
        } else if (module10.stepCompleted === STEP_COMPLETED.PRACTICE) {
          dispatch({ type: "MODULE10_SET_KEY", payload: 2 });
        } else if (module10.stepCompleted === "followthebeat") {
          dispatch({ type: "MODULE10_SET_KEY", payload: 3 });
        } else if (module10.stepCompleted === "celebrate") {
          if (module10.currentday === 8 && module10.day_completed === 7) {
            dispatch({ type: "MODULE10_SET_KEY", payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: "MODULE10_SET_KEY", payload: 4 });
          }
        } else if (module10.stepCompleted === "surprise") {
          dispatch({ type: "MODULE10_SET_KEY", payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module10.stepCompleted]);

  let selectReward = () => {
    return (
      <>
        <div className="rewards">
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=""
              onClick={() => {
                dispatch({
                  type: `MODULE10_SET_REWARD${module10.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE10_SET_REWARD${module10.currentday}2`,
                  payload: false,
                });
                document.getElementById("rewardItemLeft2").style.borderColor =
                  "yellow";
                document.getElementById("rewardItemRight2").style.borderColor =
                  "white";
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=""
              onClick={() => {
                dispatch({
                  type: `MODULE10_SET_REWARD${module10.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE10_SET_REWARD${module10.currentday}1`,
                  payload: false,
                });
                document.getElementById("rewardItemRight2").style.borderColor =
                  "yellow";
                document.getElementById("rewardItemLeft2").style.borderColor =
                  "white";
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
        </div>
        <div className="greenCheckDiv">
          {displayGreenButton && (
            <img
              className="greenCheck"
              src={greenCheck}
              alt=""
              onClick={() => {
                setCheckSound(true);
                updateProgress();
                sleep(TIMING.ANIMATION_DELAY).then(() => {
                  createGameDetails(false, true);
                  if(login.grade === "Teacher Account" || login.grade === 'Free Play'){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE10_SET_DAY_UNLOCK${module10.currentday + 1}`,
                    payload: true,
                  });

                  dispatch({
                    type: "MODULE10_SET_dayCompleted",
                    payload: module10.currentday === 8 ? 9 : module10.currentday,
                  });
  
                  dispatch({
                    type: "MODULE10_SET_stepCompleted",
                    payload: STEP_COMPLETED.NOT_STARTED,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  let openPrize = () => {
    return (
      <>
        <div className="rewards">
          <div className='circle' id='rewardItemLeft'>
            <img
              src={NorthernLights}
              alt=""
              onClick={() => {
                dispatch({ type: `MODULE10_SET_PRIZE1`, payload: true });
                dispatch({ type: `MODULE10_SET_PRIZE2`, payload: false });
                document.getElementById("rewardItemLeft").style.borderColor =
                  "yellow";
                document.getElementById("rewardItemRight").style.borderColor =
                  "white";
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={Galaxy}
              alt=""
              onClick={() => {
                dispatch({ type: `MODULE10_SET_PRIZE2`, payload: true });
                dispatch({ type: `MODULE10_SET_PRIZE1`, payload: false });
                document.getElementById("rewardItemRight").style.borderColor =
                  "yellow";
                document.getElementById("rewardItemLeft").style.borderColor =
                  "white";
                setTouchButton(true);
                setDisplayGreenButton(true);
              }}
            />
          </div>
        </div>
        <div className="greenCheckDiv">
          {displayGreenButton && (
            <img
              className="greenCheck"
              src={greenCheck}
              alt=""
              onClick={() => {
                setDisplayPrize(false);
                setCheckSound(true);
                sleep(TIMING.ANIMATION_DELAY).then(() => {
                  setDisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: "MODULE10_SET_COIN",
                    payload: module10.coins - COIN_THRESHOLDS.PRIZE_UNLOCK,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module10.currentday) {
      case 1:
        setRewardOption1(UFO1);
        setRewardOption2(UFO2);
        break;
      case 2:
        setRewardOption1(Planet1);
        setRewardOption2(Planet2);
        break;
      case 3:
        setRewardOption1(Rocket1);
        setRewardOption2(Rocket2);
        break;
      case 4:
        setRewardOption1(CometBlue);
        setRewardOption2(CometOrange);
        break;
      case 5:
        setRewardOption1(Stars1);
        setRewardOption2(Stars2);
        break;
      case 6:
        setRewardOption1(Alien1);
        setRewardOption2(Alien2);
        break;
      case 7:
        setRewardOption1(Constellation1);
        setRewardOption2(Constellation2);
        break;
      case 8:
        setRewardOption1(Helmet1);
        setRewardOption2(Helmet2);
        break;
      default:
        setDisplayGreenButton(true);
        break;
    }
  }, [keyIcon]);

  const displayReview = () => {
    if (module10.currentday === 4) {
      return (
        <>
          <div className="world2reviewContainer">
            <img
              className="reviewBtns41"
              src={SingingTimeIcon}
              alt="singing button"
              onClick={() => {
                displaySinging();
              }}
            />
            <img
              className="reviewBtns42"
              src={learnBtn}
              alt="learn button"
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className="reviewBtns43"
              src={practiceBtn}
              alt="practice button"
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className="reviewBtns44"
              src={ftbBtn}
              alt="ftb button"
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className="reviewBtns45"
              src={celebrateBtn}
              alt="celebrate button"
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="world2reviewContainer">
            <img
              className="reviewBtns1"
              src={learnBtn}
              alt="learn button"
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className="reviewBtns2"
              src={practiceBtn}
              alt="practice button"
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className="reviewBtns3"
              src={ftbBtn}
              alt="ftb button"
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className="reviewBtns4"
              src={celebrateBtn}
              alt="celebrate button"
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back="/close/navigation"
          background={background}
          token={login.cookie}
          ended={() => {
            //here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module10.currentday === 4) {
              dispatch({ type: "MODULE10_SET_KEY", payload: 1 });
              playButtonAudio();
            }
            if (module10.day_completed === 9) {
              navigate("/close/navigation");
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    switch (module10.currentday) {
      case 1:
        setLearn(
          <Learn
            video={getVideo('appfiles/close/learn_day_1.mp4', login)}
            songVideo={getVideo(`appfiles/close/learn_video.mp4`, login)}
            closingVideo={getVideo('appfiles/close/learn_day_1_closing.mp4', login)}
            destiny="/close"
            song={getVideo("appfiles/close/close_full_song_example.m4a", login)}
            back="/close"
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed="MODULE10_SET_stepCompleted"
            module={module10}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video={getVideo('appfiles/close/learn_day_2.mp4', login)}
            songVideo={getVideo(`appfiles/close/learn_video.mp4`, login)}
            closingVideo={getVideo('appfiles/close/learn_day_2_closing.mp4', login)}
            destiny="/close"
            song={getVideo("appfiles/close/close_full_song_example.m4a", login)}
            back="/close"
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed="MODULE10_SET_stepCompleted"
            module={module10}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video={getVideo('appfiles/close/learn_day_3.mp4', login)}
            songVideo={getVideo(`appfiles/close/learn_video.mp4`, login)}
            closingVideo={getVideo('appfiles/close/learn_day_3_closing.mp4', login)}
            destiny="/close"
            song={getVideo("appfiles/close/close_full_song_example.m4a", login)}
            back="/close"
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed="MODULE10_SET_stepCompleted"
            module={module10}
          />
        );
        break;
      default:
        setAnimalVoice(getVideo("appfiles/close/close_learn_intro.mp3", login));
        setDisplayVoice(true);
        setAnimalState(learnIntro);
        setShowAnimal(true);
        GetUserVideo(`userfiles/${module10.StudentID}/close_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module10.currentday-4]}/close_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={getVideo(`appfiles/close/learn_video.mp4`, login)}
                    destiny="/close"
                    song={data}
                    back="/close"
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed="MODULE10_SET_stepCompleted"
                    module={module10}
                    instrumental={getVideo("appfiles/close/close_full_song.m4a", login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={getVideo(`appfiles/close/learn_video.mp4`, login)}
                    destiny="/close"
                    song={getVideo("appfiles/close/close_full_song_example.m4a", login)}
                    back="/close"
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed="MODULE10_SET_stepCompleted"
                    module={module10}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    let text = [
      'Press record and say, "Goodbye!"',
      'Press record and say, "See you later!"',
      'Press record and say, "Bye!"',
      'Press record and say, "See you soon!"',
      'Press record and say, "Have a great day!"',
    ];
    switch (module10.currentday) {
      case 1:
        setDisplayPractice(true);
        break;
      case 2:
        setDisplayPractice(true);
        break;
      case 3:
        setDisplayPractice(true);
        break;
      default:
        let introVideo = getVideo('appfiles/close/practice_instructions.mp4', login);
        setAnimalVoice(getVideo("appfiles/close/close_practice_intro.mp3", login));
        setAnimalState(practiceIntro);
        setShowAnimal(true);
        setDisplayVoice(true);
        GetUserVideo(`influencers/${influencers[module10.currentday-4]}/close_video_message.mp4`).then((influencerVideo) => {
          GetUserVideo(`userfiles/${module10.StudentID}/greet_practice_video_${module10.currentday + 1}.mp4`).then((greetingResponse) => {
            GetUserVideo(`userfiles/${module10.StudentID}/answer_practice_video_${module10.currentday + 1}.mp4`).then((response7) => {
              GetUserVideo(`userfiles/${module10.StudentID}/ask_practice_video_${module10.currentday + 1}.mp4`).then((ask) => {
                GetUserVideo(`userfiles/${module10.StudentID}/respond_practice_video_${module10.currentday + 1}.mp4`).then((acknowledge) => {
                  setDay4Practice(
                    <Day4Practice
                      bigAnimal={true}
                      module={module10}
                      celebrateVideo={introVideo}
                      response7={response7}
                      acknowledge={acknowledge}
                      greetingResponse={greetingResponse}
                      acknowledge7={getVideo(`appfiles/close/close_acknowledge_${module10.currentday + 1}.mp4`, login)}
                      question7={getVideo(`appfiles/close/close_question_${module10.currentday + 1}.mp4`, login)}
                      ask={ask}
                      response={getVideo(`appfiles/close/close_response_${module10.currentday + 1}.mp4`, login)}
                      background={background}
                      influencerVideo={influencerVideo}
                      question={getVideo(`appfiles/close/close_close_${module10.currentday + 1}.mp4`, login)}
                      close={getVideo(`appfiles/close/close_close_${module10.currentday + 1}.mp4`, login)}
                      text={text[module10.currentday - 4]}
                      voice1={getVideo(`appfiles/close/close_practice_record_${module10.currentday + 1}.mp3`, login)}
                      voice2={getVideo("appfiles/close/close_practice_special_message.mp3", login)}
                      voice3={getVideo("appfiles/close/close_practice_watch_conversation.mp3", login)}
                      voice4={getVideo(`appfiles/close/close_awesome_job.mp3`, login)}
                      animate2={specialMessage}
                      animate3={watchConversation}
                      animate4={amazingJob}
                      name={`close_practice_video_${
                        module10.currentday + 1
                      }.mp4`}
                      greeting={getVideo(`appfiles/close/close_greeting_${module10.currentday + 1}.mp4`, login)}
                      closeVoice={getVideo(`appfiles/close/close_awesome_job.mp3`, login)}
                      animal={animal}
                      setDisplayDay4Practice={setDisplayDay4Practice}
                      moduleNum={MODULE_NUM}
                    />
                  );
                });
              });
            });
          });
        });
        setDisplayDay4Practice(true);
        break;
    }
  };

  const openFTB = async () => {
    setAnimalVoice(getVideo("appfiles/close/close_ftb_intro.mp3", login));
    setAnimalState(ftbIntro);
    setShowAnimal(true);
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    let celebrateVideo1 = getVideo('appfiles/close/celebrate_day_1.mp4', login);
    let celebrateVideo2 = getVideo('appfiles/close/celebrate_day_2.mp4', login);
    let celebrateVideo3 = getVideo('appfiles/close/celebrate_day_3.mp4', login);

    switch (module10.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module10}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module10}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module10}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={MODULE_NUM}
          />
        );
        break;
      default:
        setAnimalVoice(getVideo("appfiles/close/close_celebrate_intro.mp3", login));
        setDisplayVoice(true);
        setAnimalState(celebrateIntro);
        setShowAnimal(true);
        await GetUserVideo(`influencers/${influencers[module10.currentday-4]}/close_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              module={module10}
              background={background}
              voice1={getVideo("appfiles/close/close_celebrate_record_believe.mp3", login)}
              voice2={getVideo("appfiles/close/close_celebrate_say_believe.mp3", login)}
              voice3={getVideo("appfiles/distance/practice_amazing_job.mp3", login)}
              text={
                'Record yourself in an excited voice and say, "I believe in me!"'
              }
              name={`close_celebration_surprise_${
                module10.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={amazingJob}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={MODULE_NUM}
              bigAnimal={true}
            />
          );
        });
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    let introVideo = getVideo('appfiles/close/singing_time.mp4', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={getVideo("appfiles/close/close_full_song_example.m4a", login)}
        singingVideo={getVideo("appfiles/close/close_student_notes.mp4", login)}
        background={background}
        singingMusic={getVideo("appfiles/close/close_full_song_example.m4a", login)}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module10}
        moduleNum={MODULE_NUM}
        name="close"
        instrumental={getVideo("appfiles/close/close_full_song_instrumental.m4a", login)}
        instrumentalURL={"appfiles/close/close_full_song.m4a"}
      />
    );
    setDisplaySingingTime(true);
  };

  let getSurprise = async () => {
    
    let usePhoto = [
      {
        video: `influencers/${login.influencerid}/close_affirmation.mp4`,
      },
      {
        video: `userfiles/${module10.StudentID}/close_celebration_surprise_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/close_affirmation.mp4`,
      },
      {
        video: `appfiles/close/close_response_5.mp4`,
      },
      {
        video: `userfiles/${module10.StudentID}/greet_practice_video_5.mp4`,
      },
      {
        video: `appfiles/close/close_question_5.mp4`,
      },
      {
        video: `userfiles/${module10.StudentID}/answer_practice_video_5.mp4`,
      },
      {
        video: "appfiles/close/close_acknowledge_5.mp4",
      },
      {
        video: `userfiles/${module10.StudentID}/ask_practice_video_5.mp4`,
      },
      {
        video: `appfiles/close/close_response_5.mp4`,
      },
      {
        video: `userfiles/${module10.StudentID}/respond_practice_video_5.mp4`,
      },
      {
        video: "appfiles/close/close_close_5.mp4",
      },
      {
        video: `userfiles/${module10.StudentID}/close_practice_video_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/close_video_message.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/close_affirmation.mp4`,
      },
      {
        video: `userfiles/${module10.StudentID}/close_celebration_surprise_9.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/close_affirmation.mp4`,
      },
    ];

    for (let i = 0; i < usePhoto.length; i++) {
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }

    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo("appfiles/close/close_full_song_instrumental.m4a", login)}
          animal={animal}
          back={"/"}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });
    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const coinAnimation = () => {
    setCoinAnimationState("coinAnimation");
    setCoinAudio(true);
  };

  const eggAnimation = () => {
    setKeyState("fade-out");
    eggCrackAudio.play();
    setEggHalf(true);
    sleep(TIMING.EGG_ANIMATION_DELAY).then(() => {
      setEggHalf(false);
      setEggState(eggBottom);
      setEggAnimationState("eggAnimate");
      setEggAnimate(true);
      sleep(1500).then(() => {
        setRewardsFound(true);
        setDisplayReward(true);
        setKeyIcon(false);
      });
    });
  };

  const closeDay9Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setIntroVideo(AfterCelebrateVideo9);
  };

  const playButtonAudio = () => {
    sleep(TIMING.BUTTON_AUDIO_DELAY).then(() => {
      setButtonSound(true);
    });
  };

  return (
    <>
      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({
              type: "MODULE10_SET_COIN",
              payload: module10.coins + 1,
            });
            setCoinAudio(false);
            setCoinAnimationState("bounceIcons");
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl("media/Module5Videos/earn_token.mp3")
            }
            type="audio/mp3"
          />
        </audio>
      )}
      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl("media/Module1Videos/button_accept_item.mp3")
            }
            type="audio/mp3"
          />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl("media/Module2Videos/daily_rewards_present.mp3")
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl("media/Module1Videos/touch_button.mp3")
            }
            type="audio/mp3"
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl("media/Module1Videos/button_bouncing.mp3")
            }
            type="audio/mp3"
          />
        </audio>
      )}
      {/* Always-mounted animal voice audio for iOS reliability */}
      {displayVoice && <audio
        src={animalVoice}
        playsInline
        autoPlay
        onPlay={() => {
          setAudioReady(true);
        }}
        onEnded={() => {
          setAudioReady(false);
          setDisplayVoice(false);
          setAnimalState("");
          setShowAnimal(false);
          if (playAnimalClose) {
            setPlayAnimalClose(false);
            module10.currentday === 8 ? closeDay9Video() : navigate("/close/navigation");
          }
        }}
      />}
      {displayIntroVideo && introduction()}
      {!showAnimal && displayLearn && learn}
      {displayPractice && (
        <Practice
          setDisplayPractice={setDisplayPractice}
          background={background}
          stepComplete={"MODULE10_SET_stepCompleted"}
          module={module10}
          unit2={true}
        />
      )}
      {!showAnimal && displayDay4Practice && day4Practice}
      {!showAnimal && displayFTB && (
        <FollowTheBeatModule10
        setDisplayFTB={setDisplayFTB}
        awesomeJobGIF={birdAwesomeJobGIF}
        awesomeJob={birdAwesomeJob}
        instruction={ftbInstruction}
        instructionGIF={ftbInstructionGIF}
        song={ftbMusic}
        count={ftbCount}
        tutorial1={ftbTutorial1}
        tutorial2={ftbTutorial2}
        walkthrough={ftbWT}
        stepComplete={'MODULE10_SET_stepCompleted'}
        module={module10}
        score={'ftb_close'}
        />
      )}
      {!showAnimal && displayCelebrate && celebrate}
      {displaySingingTime && singTime}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showAnimal) && (
        <div
          className="closeWorldBody"
          style={{
            backgroundImage: `url(${
              generateImageUrl("images/newDesign/Unit2Module10/World10SkyOnly.png")
            })`,
          }}
        >
          <img className="mountain" src={mountain}/>
          <div className="navigation">
            <img
              className="logoutBtn"
              src={logoutBtn}
              alt="Logout Button"
              onClick={togglePopup}
            />
            <img
              className="JourneyBlueImage"
              src={journeyImage}
              alt="Navigation blue world Image"
              onClick={() => {
                navigate("/close/navigation");
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id="title">
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id="logoutButton1"
                    className="logoutButton"
                    onClick={() => {
                      navigate("/");
                      userHasAuthenticated(false);
                      localStorage.setItem("token", "false");
                    }}
                  >
                    YES
                  </button>
                  <button
                    id="logoutButton2"
                    className="logoutButton"
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className="prize"
              src={
                generateImageUrl("images/Images/prize.png")
              }
              alt="Logout Button"
              onClick={() => {
                setPrize(false);
                sleep(1400).then(() => {
                  sleep(TIMING.KEY_ANIMATION_DELAY).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className="prize-button"
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {" "}
              <h5>Click Here</h5>
            </button>
          )}
          {displayPrize && openPrize()}
          
          <div className="Bird_Container">
            {showAnimal && (
              <img className="birdCharacterGif" style={audioReady ? {} : { display: "none" }} src={animalState} alt="monkey Icon" onLoad={() => setDisplayVoice(true)} onError={() => setShowAnimal(false)}/>
            )}
            <img
              className="birdCharacter"
              src={animal}
              alt="bird Icon"
            />
            {module10.rewards.Helmet1 && (
              <img className="Helmet1" src={Helmet1} alt="" />
            )}
            {module10.rewards.Helmet2 && (
              <img className="Helmet2" src={Helmet2} alt="" />
            )}
            <img className="Bird_Egg" src={eggState} alt="Egg Icon" />
            <img className="Bird_Nest" src={nest} alt="Egg Icon" />
            {eggHalf && (
              <img
                className="Bird_Egg"
                src={eggHalfCracked}
                id={"eggFade"}
                alt="Egg Icon"
              />
            )}
            {eggAnimate && (
              <img
                className="Bird_Egg"
                src={eggTop}
                id={eggAnimationState}
                alt="Egg Icon"
              />
            )}
          </div>

          <div className="scoreBar">
            <img
              className="scoreKey"
              src={coinBar}
              alt="crab Icon"
            />
            {module10.coins < COIN_THRESHOLDS.TWO_DIGIT && (
              <h5 className="scoretext1">{module10.coins}</h5>
            )}
            {module10.coins >= COIN_THRESHOLDS.TWO_DIGIT && module10.coins < COIN_THRESHOLDS.THREE_DIGIT && (
              <h5 className="scoretext10">{module10.coins}</h5>
            )}
            {module10.coins >= COIN_THRESHOLDS.THREE_DIGIT && (
              <h5 className="scoretext100">{module10.coins}</h5>
            )}
            <p className="scoretext">{COIN_THRESHOLDS.PRIZE_UNLOCK}</p>
          </div>

          {module10.currentday === 4 || module10.currentday === 8 ? (
            <div className="progressBar3">
              <img
                className="progressKey3"
                src={keys5[module10.keys]}
                alt="crab Icon"
              />
              <h3 className="progresstext3">{module10.keys}/5</h3>
            </div>
          ) : (
            <div className="progressBar3">
              <img
                className="progressKey3"
                src={keys4[module10.keys]}
                alt="crab Icon"
              />
              <h3 className="progresstext3">{module10.keys}/4</h3>
            </div>
          )}

          {!showAnimal && !module10.reviewIcon && !coinIcon && !displayPrize && (
            <div className="actionBtnDiv">
              {module10.currentday === 4 &&
                module10.stepCompleted === STEP_COMPLETED.NOT_STARTED && (
                  <img
                    id="bounceIcons"
                    className="actionBtn2"
                    src={SingingTimeIcon}
                    alt="learn button"
                    onClick={() => {
                      setTouchButton(true);
                      sleep(TIMING.ANIMATION_DELAY).then(() => {
                        displaySinging();
                        setCheckStep("singingtime");
                      });
                    }}
                  />
                )}
              {module10.currentday !== 4 &&
                module10.stepCompleted === STEP_COMPLETED.NOT_STARTED && (
                  <img
                    id="bounceIcons"
                    className="actionBtn2"
                    src={learnBtn}
                    alt="learn button"
                    onClick={() => {
                      setTouchButton(true);
                      sleep(TIMING.ANIMATION_DELAY).then(() => {
                        openLearn();
                        setCheckStep("learn");
                      });
                    }}
                  />
                )}

              {module10.stepCompleted === STEP_COMPLETED.LEARN && (
                <img
                  className="actionBtn2"
                  src={practiceBtn}
                  id="bounceIcons"
                  alt="practice button"
                  onClick={() => {
                    touchSound.play()
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openPractice();
                      setCheckStep("practice");
                    });
                  }}
                />
              )}

              {module10.stepCompleted === STEP_COMPLETED.PRACTICE && (
                <img
                  className="actionBtn2"
                  src={ftbBtn}
                  id="bounceIcons"
                  alt="celebrate button"
                  onClick={() => {
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openFTB();
                      setCheckStep("followthebeat");
                    });
                  }}
                />
              )}

              {module10.stepCompleted === "followthebeat" && (
                <img
                  className="actionBtn2"
                  src={celebrateBtn}
                  id="bounceIcons"
                  alt="celebrate button"
                  onClick={() => {
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openCelebrate();
                      setCheckStep("celebrate");
                    });
                  }}
                />
              )}

              {module10.stepCompleted === "singingtime" && (
                <img
                  className="actionBtn2"
                  src={learnBtn}
                  id="bounceIcons"
                  alt="singing button"
                  onClick={() => {
                    setTouchButton(true);
                    sleep(TIMING.ANIMATION_DELAY).then(() => {
                      openLearn();
                      setCheckStep("learn");
                    });
                  }}
                />
              )}
            </div>
          )}

          {!showAnimal && coinIcon && !displayPrize && (
            <div className="actionBtnDiv">
              {module10.reviewIcon === false && (
                <img
                  id={coinAnimationState}
                  src={coinPick}
                  alt="reward key"
                  style={{
                    position: "absolute",
                    top: "50vh",
                    left: "50vw",
                    width: "100px",
                    height: "100px",
                    marginLeft: "-50px",
                    marginTop: "-50px",
                    zIndex: 10,
                  }}
                  onClick={() => {
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!displayPrize &&
            !showAnimal &&
            !displayReward && (
              <div className="actionBtnDiv">
                {module10.reviewIcon && (
                <img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt="review button"
                  onClick={() => {
                    setReviewIcon(!reviewIcon);
                  }}
                />)}
                {showReward && (
                  <img
                    src={rewardBtn}
                    className='actionBtn4'
                    alt='review button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(TIMING.ANIMATION_DELAY).then(() => {
                        eggAnimation();
                      });
                    }}
                />)}
                {module10.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {!coinIcon && keyIcon && !displayPrize && (
            <img
              className="rewardsIcon"
              id={keyState}
              style={{
                width: "150px",
                height: "40px",
                marginLeft: "-75px",
                zIndex: 10,
              }}
              src={keyReward}
              alt="reward key"
              onClick={() => {
                eggAnimation();
              }}
            />
          )}
          {displayReward && selectReward()}

          {!displayPrize && !coinIcon && presentIcon && (
            <img
              className="present"
              style={{
                width: "84px",
                height: "100px",
                marginLeft: "-42px",
                zIndex: 10,
              }}
              id="bounceIcons"
              src={present}
              alt="gift"
              onClick={() => {
                playSurpriseVideo();
              }}
            />
          )}
          {!displayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {module10.rewards.CometOrange && (
            <img className="CometOrange" src={CometOrange} alt="" />
          )}
          {module10.rewards.CometBlue && (
            <img className="CometBlue" src={CometBlue} alt="" />
          )}
          {module10.rewards.Alien2 && (
            <img className="Alien2" src={Alien2} alt="" />
          )}
          {module10.rewards.Planet1 && (
            <img className="Planet1" src={Planet1} alt="" />
          )}
          {module10.rewards.Planet2 && (
            <img className="Planet2" src={Planet2} alt="" />
          )}
          {module10.rewards.Alien1 && (
            <img className="Alien1" src={Alien1} alt="" />
          )}
          {module10.rewards.Constellation2 && (
            <img className="Constellation2" src={Constellation2} alt="" />
          )}
          {module10.rewards.Stars1 && (
            <img className="Stars1" src={Stars1} alt="" />
          )}
          {module10.rewards.Stars2 && (
            <img className="Stars2" src={Stars2} alt="" />
          )}
      
          {module10.rewards.Constellation1 && (
            <img className="Constellation1" src={Constellation1} alt="" />
          )}
          {module10.rewards.UFO2 && <img className="UFO2" src={UFO2} alt="" />}
          {module10.rewards.UFO1 && <img className="UFO1" src={UFO1} alt="" />}
          {module10.rewards.Rocket1 && (
            <img className="Rocket1" src={Rocket1} alt="" />
          )}
          {module10.rewards.Rocket2 && (
            <img className="Rocket2" src={Rocket2} alt="" />
          )}
          {module10.rewards.NorthernLights && (
            <img className="NorthernLights" src={NorthernLights} alt="" />
          )}
          {module10.rewards.Galaxy && (
            <img className="Galaxy" src={Galaxy} alt="" />
          )}
        </div>
      )}
    </>
  );
};
export default Module10World;
